<template>
    <div class="ui-input-radio" :class="wrapperClass">
        <input
            :id="id"
            :value="value"
            :checked="isChecked"
            v-bind="$attrs"
            type="radio"
            class="radio-custom"
        />
        <label :for="id"></label>
        <label :for="id"><slot /></label>
    </div>
</template>
<script>
import InputCheckbox from '../InputCheckbox'
export default {
    extends: InputCheckbox
}
</script>
<style lang="scss">
.ui-input-radio {
    label {
        cursor: pointer;
    }
}
</style>
